import Vue from 'vue';
import astConfig from './config';
import { filtUrlParams } from './filt-url-params';
import { common } from '@tencent/ceiba-base-components';
import { isAPP, currentAstName } from './util';

let gImageShareData = {};
let gShareConfig = {};

function getPlatform() {
  return isAPP() ? 'app' : '';
}

/**
 * 根据业务名称返回业务配置
 * @returns 业务配置对象
 */
const currentAstConfig = function () {
  const astName = currentAstName();
  return astConfig[astName];
};

export default {
  getPlatform,
  currentAstName,
  currentAstConfig,
  /**
   * 处理请求流程引擎额外参数
   * @returns 附加的参数
   */
  getFlowRequestExtData: async () => {
    switch (currentAstName()) {
      case 'TGCLUB': {
        // 特殊处理指挥官带货邀请码
        const zhgCode = common.tool.getQueryparams('inviteCode');
        if (zhgCode) {
          return { zhgCode };
        }
        return {};
      }
      case 'BB': {
        const userId = common.tool.getQueryparams('userId') || common.tool.getQueryparams('userid');
        const token = common.tool.getQueryparams('token');
        if (userId && token) {
          return {
            userId,
            token,
          };
        }
        return {};
      }
      default:
        break;
    }
  },
  /**
   * 初始化APP环境的分享功能
   */
  initAPPShare: async (shareConfigParams) => {
    const shareConfig = shareConfigParams ? shareConfigParams : Vue.prototype?.$storeInstance?.state?.shareConfig;
    console.log('app initAPPShare from $storeInstance', shareConfig);
    gShareConfig = shareConfig;
    switch (currentAstName()) {
      case 'TGCLUB': {
        const initializeAppShare = () => {
          window.callShare = () => {
            const packageName = Vue.prototype.$platform.isIos
              ? Vue.prototype?.$storeInstance?.state?.gameInfo.ios_pkg_name
              : Vue.prototype?.$storeInstance?.state?.gameInfo.android_pkg_name;
            window.UPBridge?.shareWebPage({
              title: shareConfig?.title || '',
              summary: shareConfig?.desc || '',
              icon: shareConfig?.icon || currentAstConfig().XY_APP_ICON,
              url: shareConfig?.link || window.location.href,
              traceConfig: {
                appId: Vue.prototype?.$storeInstance?.state?.gameInfo.qq_appid,
                packageName,
                channel: '',
                iosSchemeUrl: Vue.prototype?.$storeInstance?.state?.gameInfo.ios_url_scheme,
              },
              // eslint-disable-next-line @typescript-eslint/no-empty-function
            });
          };
          const eventId = window.UPBridge?.setFunctionButton({
            hasRedDot: false,
            num: 0,
            iconUrl: 'https://game.gtimg.cn/images/tgclub/act/a20220331/more_three_point.png',
          });
          document.addEventListener(eventId, (e) => {
            const { code, msg } = e.detail;
            if (code === 0) {
              window.callShare();
            } else {
              console.error(msg);
            }
          });
        };

        if (window.UPBridge && isAPP()) {
          initializeAppShare();
        } else {
          document.addEventListener('TgclubReady', () => {
            initializeAppShare();
          });
        }
        break;
      }
      case 'SPARK': {
        break;
      }
      case 'BB': {
        if (!isAPP()) {
          return;
        }
        console.log('app initAPPShare', shareConfig);
        // let gShareConfig = shareConfig;
        window.shareIndex = function () {
          if (typeof (window.GameHelper) !== 'undefined' && typeof (window.GameHelper?.shareWebPageWithFuntion) !== 'undefined') {
            window.GameHelper?.shareWebPageWithFuntion(
              shareConfig?.title || '',
              shareConfig?.desc || '',
              shareConfig?.icon || '',
              shareConfig?.link || window.location.href,
              '1,2,3,4,5,8',
              0,
            );
          }
        };
        break;
      }
      default:
        break;
    }
  },
  setAPPShare: async (params) => {
    Vue.prototype?.$storeInstance?.mutations?.UPDATE_SHARE_CONFIG(params);
    gShareConfig = params;
  },
  goAPPShare: async (shareConfigParams) => {
    const shareConfig = shareConfigParams || gShareConfig || Vue.prototype?.$storeInstance?.state?.shareConfig;
    switch (currentAstName()) {
      case 'TGCLUB': {
        if (isAPP() && window.UPBridge) {
          const shareCallBack = typeof shareConfig?.callback !== 'undefined' ? shareConfig.callback : null;
          const packageName = Vue.prototype.$platform.isIos
            ? Vue.prototype?.$storeInstance?.state?.gameInfo.ios_pkg_name
            : Vue.prototype?.$storeInstance?.state?.gameInfo.android_pkg_name;
          const xinyueAppShare = {
            title: shareConfig?.title,
            summary: shareConfig?.desc,
            icon: currentAstConfig().XY_APP_ICON,
            url: shareConfig?.link || window.location.href,
            traceConfig: {
              appId: Vue.prototype?.$storeInstance?.state?.gameInfo.qq_appid,
              packageName,
              channel: '',
              iosSchemeUrl: Vue.prototype?.$storeInstance?.state?.gameInfo.ios_url_scheme,
            },
          };
          // 心悦app ios 回调是一个函数 () =>{}
          // 心悦 安卓  回调是一个 函数字符串  "() =>{}"
          console.log('tgclub  goAPPShare xinyue  share config =', xinyueAppShare, ' shareCallBack =', shareCallBack);
          // window.UPBridge?.shareWebPage(JSON.stringify(xinyueAppShare), shareCallBack);
          window.UPBridge?.shareWebPage(xinyueAppShare).then(res =>  (typeof shareCallBack === 'function' ? shareCallBack(res) : ''));
        }
        break;
      }
      case 'SPARK': {
        const shareData = {
          title: shareConfig?.title,
          summary: shareConfig?.desc,
          targetUrl: shareConfig?.link || window.location.href,
          thumbUrl: shareConfig?.icon,
          callback: shareConfig?.callback,
        };
        const res = await window.SX_WEB?.jsBridge.share.showShareDialog(shareData);
        console.log('spark app share res:', res);
        const type = typeof shareData?.callback;
        if (type !== 'undefined' && type === 'function') {
          shareData.callback(res);
        }
        return res;
      }
      case 'BB': {
        const { title, desc, link: url, icon } = shareConfig;
        const type = '1,2,3,4,5,8';
        window?.GameHelper?.shareWebPageWithFuntion(
          title,
          desc,
          icon,
          url,
          type,
          0,
        );
        break;
      }
      default:
        break;
    }
  },
  disableAPPShare: async () => {
    switch (currentAstName()) {
      case 'TGCLUB': {
        if (window.UPBridge && isAPP()) {
          if (navigator.userAgent.toLowerCase().includes('tgclub')) {
            // 隐藏分享按钮
            const { isIos } = common.platform;
            console.log('this.configurationData in hideFunctionButton ios', isIos);
            if (isIos) {
              // ios
              console.log('this.configurationData in hideFunctionButton ios');
              window.document.addEventListener(
                'TgclubReady',
                () => {
                  console.log('this.configurationData in hideFunctionButton ');
                  window.UPBridge?.hideFunctionButton();
                },
                false,
              );
              window.UPBridge?.hideFunctionButton();
              console.log('is success');
            } else {
              // if ('undefined' != typeof (window.UPBridge)) { // 安卓
              console.log('this.configurationData in hideFunctionButton');
              window.UPBridge?.hideFunctionButton();
              console.log('is success');
              // }
            }
          }
        }
        break;
      }
      case 'SPARK': {
        break;
      }
      case 'BB': {
        break;
      }
      default:
        break;
    }
  },
  /**
   * 图片分享
   */
  setImageShare: async (params) => {
    switch (currentAstName()) {
      case 'SPARK': {
        gImageShareData = params;
        console.log('shanxian imageShare params=', params);
        break;
      }
      case 'BB': {
        break;
      }
      default:
        break;
    }
  },
  imageShare: async () => {
    switch (currentAstName()) {
      case 'SPARK': {
        const res = await window.SX_WEB?.jsBridge.share.showShareDialogV2(gImageShareData);
        return res;
      }
      case 'BB': {
        break;
      }
      default:
        break;
    }
  },
  isAPP,
  gotoAPP: async (link, params = { ch: '' }) => {
    switch (currentAstName()) {
      case 'TGCLUB': {
        console.log('tgclub gotoAPP');
        if (isAPP()) {
          return false;
        }
        let url = link || window.location.href;
        // 强制更新成活动traceId
        const traceId = window.ceibaTraceId;
        url = common.tool.setUrlParam('trace_id', traceId, url);
        url = filtUrlParams(url);
        // 跳转tgclub:// 最外层协议 需要加上 trace_id
        const schemaUrl = `tgclub://redirect?url=${encodeURIComponent(url)}&share=0&trace_id=${traceId}`;
        if (!isAPP()) {
          if (!Vue.prototype.$platform.isIos && !Vue.prototype.$platform.isAndroid) {
            Vue.prototype.alert('仅适用IOS或Android');
            return;
          }
          if (Vue.prototype.$platform.isWX) {
            // 微信体系，使用wxJsBridge
            const timer = setTimeout(() => {
              clearTimeout(timer);
              window.WeixinJSBridge.invoke(
                'launchApplication',
                {
                  schemeUrl: schemaUrl,
                },
                (res) => {
                  // 微信内启动失败,跳转安装
                  if (res.err_msg.indexOf('fail') !== -1) {
                    if (Vue.prototype.$platform.isIos) {
                      // 微信ios
                      window.location.href = currentAstConfig().IOS_DOWNLOAD_URL;
                    } else if (Vue.prototype.$platform.isAndroid) {
                      // 微信安卓
                      window.location.href = currentAstConfig().ANDROID_DOWNLOAD_URL;
                    }
                  }
                },
              );
            }, 500);
            return;
          }
          // IOS 手Q
          if (Vue.prototype.$platform.isIos && Vue.prototype.$platform.isQQ) {
            // ios的browser
            window.location.href = schemaUrl;
            setTimeout(() => {
              //  on.download && on.download();
              window.location.href = currentAstConfig().IOS_DOWNLOAD_URL;
            }, 500);
          }
          // 剩下的情况 QQ 或者 安卓
          window.location.href = schemaUrl;
          // 延迟2.5秒跳转到安装地址
          const timer = setTimeout(() => {
            if (Vue.prototype.$platform.isIos) {
              window.location.href = currentAstConfig().IOS_DOWNLOAD_URL;
            } else if (Vue.prototype.$platform.isAndroid) {
              window.location.href = currentAstConfig().ANDROID_DOWNLOAD_URL;
            }
          }, 2500);
          // 判断是否隐藏页面,如隐藏则清除timer
          let visibilityChange = 'visibilitychange';
          if (typeof document.hidden !== 'undefined') {
            visibilityChange = 'visibilitychange';
          } else if (typeof document.mozHidden !== 'undefined') {
            visibilityChange = 'mozvisibilitychange';
          } else if (typeof document.msHidden !== 'undefined') {
            visibilityChange = 'msvisibilitychange';
          } else if (typeof document.webkitHidden !== 'undefined') {
            visibilityChange = 'webkitvisibilitychange';
          }
          document.addEventListener(
            visibilityChange,
            (event) => {
              const isHidden = Vue.prototype.$platform.isIos ? event.hidden : document.hidden;
              if (isHidden) {
                clearTimeout(timer);
              }
            },
            false,
          );
        }
        break;
      }
      case 'SPARK': {
        console.log('launchApp Vue.prototype.$actInfo', Vue.prototype.$actInfo);
        console.log('gotoApp');
        if (!isAPP()) {
          let url = link ? link : window.location.href;
          // 强制更新成活动traceId
          const traceId = window.ceibaTraceId;
          url = common.tool.setUrlParam('trace_id', traceId, url);
          const ch = params.ch ? params.ch : common.tool.getQueryparams('ch');
          const actInfo = Vue.prototype.$actInfo;
          const pageId = actInfo.page_id;
          const { reportPv = '' } = actInfo.config.configs[pageId].canvasConfig;
          console.log('launchApp reportPv', reportPv);
          const reportSz = reportPv.split('|');
          const reportGs = reportSz.length;
          console.log('launchApp reportGs', reportGs);
          const prevIda = '';
          if (reportGs === 3) {
            const prevIda = reportSz[2];
            console.log('launchApp prevIda', prevIda);
          }
          window.SX_WEB?.app.launch({
            href: url,
            autoInstall: true,
            prevId: prevIda,
            downloadUrlParams: {
              shanxianinchannel: ch,
              sxaction: 'download',
            },
          });
        } else {
          console.log('shanxian app 内');
          window.SX_WEB?.jsBridge.ui.openView({ options: link });
        }
        break;
      }
      case 'BB': {
        console.log('bb gotoAPP');
        if (isAPP()) {
          return false;
        }
        const gid = Vue.prototype.$actInfo?.gid || '1261';
        const title = currentAstConfig()?.GAMEINFO[gid]?.title || '掌火助手';
        const msg = `请前往${title}参与活动`;
        Vue.prototype.alert(msg);
        break;
      }
      default:
        break;
    }
  },
  openView: (options) => {
    switch (currentAstName()) {
      case 'TGCLUB': {
        const { url = '#' } = options;
        if (window.UPBridge && isAPP()) {
          window.UPBridge?.openNewWebview({ url });
        } else {
          window.location.href = url;
        }
        break;
      }
      case 'SPARK': {
        window.SX_WEB?.jsBridge.ui.openView({ options: options.url });
        break;
      }
      case 'BB': {
        break;
      }
      default:
        break;
    }
  },
  callAndDownLoadGame: (async () => {
    switch (currentAstName()) {
      case 'TGCLUB': {
        const gameInfo = {};
        return async function ({ gid, isNeedDownload }) {
          console.log('------------callAndDownLoadGame', gid, isNeedDownload, Vue.prototype?.$actInfo?.activity_id);
          if (!gid || (!window.UPBridge && !isAPP())) return false;
          if (!gameInfo.packagename) {
            const response = await Vue.prototype.$axiosInstance.get(`https://wang.xinyue.qq.com/api/fly/getPkgByGid?gid=${gid}`);
            if (parseInt(response.ret, 10) === 0 && response.info.androidDownloadUrl) {
              const data = response.info || {};
              if (!data.androidPkgName) {
                console.error('download androidPkgName params empty ', response);
                return false;
              }
              data.icon = typeof data.icon === 'string' && data.icon ? JSON.parse(data.icon) : data.icon;
              gameInfo.icon = !!data.icon[108] === true ? data.icon[108] : data.icon[16];
              gameInfo.packagename = data.androidPkgName;
              gameInfo.version = data.version;
              gameInfo.gamename = data.gameName;
              gameInfo.channelid = data.channelNum;
              gameInfo.iosurl = data.IOSDownloadUrl;
              gameInfo.url = data.androidDownloadUrl;
              gameInfo.iOSPkgName = data.iosPkgName || data.androidPkgName;
              gameInfo.gid = data.gid;
              gameInfo.gameAppID = data.ext2;
              gameInfo.from = '1015';
              gameInfo.md5 = data?.apk_md5;
              gameInfo.iosDownloadUrl = data?.iosDownloadUrl;
              gameInfo.iosUrlScheme = data?.iosUrlScheme;
              gameInfo.activityId = Vue.prototype?.$actInfo?.activity_id ?? 0;
              if (common.tool.getQueryparams('adreport') !== null) {
                gameInfo.from += `*${common.tool.getQueryparams('adreport')}`;
              }
            } else {
              Vue.prototype.alert('系统繁忙，请刷新页面重试');
            }
          }

          // const jsonStr = JSON.stringify(gameInfo);
          const params = {
            packageName: gameInfo.packagename,
            version: gameInfo.version,
            gameName: gameInfo.gamename,
            icon: gameInfo.icon,
            url: gameInfo.url,
            channelId: gameInfo.channelid,
            from: '1015',
            md5: gameInfo.md5,
            gameAppID: gameInfo.gameAppID,
            isSilent: false,
            iOSPkgName: gameInfo.iOSPkgName,
            iosUrl: gameInfo.iosDownloadUrl,
            iosSchemeUrl: gameInfo.iosUrlScheme,
            activityId: gameInfo.activityId,
            gid: gameInfo.gid,
          };

          if (common.platform.isIos) {
            // window.UPBridge?.downloadApp(jsonStr, (ret) => {
            //   /* eslint-disable-next-line */
            //   var jsonArr = JSON.parse(ret);
            // });
            window.UPBridge?.downloadApp(params);
            window.UPBridge?.downloadComponentExpose(params);
            return true;
          }
          const response = await window.UPBridge?.getAppInstalledChannel({ pkgName: gameInfo.packagename, channelTag: 'channelId' }) || {};
          const { data = {} } = response;
          if (data.channelInfo && typeof window.UPBridge?.openExternalAppByPkgName === 'function' && channelId > 0) {
            window.UPBridge?.openExternalAppByPkgName({ pkgName: `tgclub://${gameInfo.packagename}` });
            return true;
          }
          if (isNeedDownload) {
            let queryData = await window.UPBridge?.checkDownloadState({ url: gameInfo.url });
            queryData = queryData || {};
            const { state = 1 } = queryData.data || {};
            switch (state) {
              case 1:
                window.UPBridge?.downloadApp(params);
                Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}开始下载中`);
                break;
              case 2:
                Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}下载中`);
                break;
              case 3:
                window.UPBridge?.continueDownloadApp({ url: gameInfo.url });
                Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}下载中`);
                break;
              case 4:
                // 安装游戏
                window.UPBridge?.installDownloadApp({ url: gameInfo.url });
                Vue.prototype?.$toast(`${gameInfo.gamename || '游戏'}准备安装中`);
                break;
              default:
                break;
            }
            return false;
          }
        };
      }
      case 'SPARK': {
        break;
      }
      case 'BB': {
        break;
      }
      default:
        break;
    }
  })(),
  /**
   * @deprecated
   * @returns 微信分享appid
   */
  getAstConfig: () => {
    const astConfig = currentAstConfig();
    astConfig.shareWxAppId = astConfig.SHARE_WX_APP_ID;
    return astConfig;
  },
  // 构建分享回调函数 用于应对每个分享回调
  // 心悦分享不能的回调不能直接进行网络请求
  // 出触发莫名的错误
  // componentCallBackFunc 是触发回调的函数
  // caller 是触发回调的函数的对象  一般是Vue 中 this
  // params 是触发回调的参数，数组[params1,params2]
  makeAPPShareCallBack: () => function (funcName, thisArg) {
    switch (currentAstName()) {
      case 'TGCLUB': {
        if (!isAPP()) {
          return funcName.bind(thisArg);
        }
        Object.defineProperty(window, 'hasTgclubShareAction', {
          set: (newValue) => {
            if (newValue > 0) {
              console.log('分享成功~~~~~~~~~~~~~~~~~~~~~~~');
              if (typeof funcName === 'function') {
                funcName.apply(thisArg);
              }
            }
          },
          enumerable: true,
          configurable: true,
        });
        return  function (ret) {
          console.log(' 分享 回调 ret =', ret);
          const { result = 0 } = ret?.data || {};
          window.hasTgclubShareAction = 0;
          if (parseInt(result, 10) === 1) {
            window.hasTgclubShareAction = 1;
            console.log('分享 回调~~suc');
          } else {
            console.log('分享 回调~~失败');
          }
        };
      }
      case 'SPARK': {
        break;
      }
      case 'BB': {
        break;
      }
      default:
        break;
    }
  },
  /**
   * 获取分享url
   * @param {type} help:助力 team:组队
   * @param {ch} 渠道号
   * @param {url} 链接
   */
  getShareUrl: async (params = { userInfo: {}, type: 'help', url: '' }) => {
    switch (currentAstName()) {
      case 'SPARK': {
        console.log('share params', params);
        const avatar = params.userInfo.avatar ? params.userInfo.avatar : '';
        let nickName = params.userInfo.nickname || params.userInfo.nickName;
        nickName = nickName ? nickName : '闪现用户';
        const uid = common.tool.getCookie('uid');

        const url = params.url ? params.url : `${window.location.origin + window.location.pathname}?c_page=1`;
        const shareUrl = common.tool.setUrlParams({
          avatar,
          nickName,
          inviter: params.userInfo.openid,
          uid,
          // ch: params.ch,
          type: params.type,
        }, url);
        return shareUrl;
      }
      case 'BB': {
        break;
      }
      default:
        break;
    }
  },
  // app外拉起内置页面用scheme
  openScheme: async (url, params = { ch: '' }) => {
    switch (currentAstName()) {
      case 'SPARK': {
        const ch = params.ch ? params.ch : common.tool.getQueryparams('ch');
        console.log('openscheme');
        window.SX_WEB?.app.launch({
          scheme: url,
          autoInstall: true,
          downloadUrlParams: {
            shanxianinchannel: ch,
            sxaction: 'download',
          },
        });
        break;
      }
      case 'BB': {
        break;
      }
      default:
        break;
    }
  },
};
